import categories from "@/blog/categories";

import BlogBest3Tools from "@/blog/articles/BlogBest3Tools";
import BlogWhyLinkedinIsBad from "@/blog/articles/BlogWhyLinkedinIsBad";
import BlogUsingCommunities from "@/blog/articles/BlogUsingCommunities";

export default [
  {
    path: "/blog/using-communities-to-find-hidden-top-talent ",
    component: BlogUsingCommunities,
    meta: {
      requireAuth: false,
      name: "Using communities to find hidden top talent",
      createdAt: new Date(2021, 4, 13),
      imageName: "jobboardy-hero-web.png",
      category: categories.jobSearch,
    },
  },
  {
    path: "/blog/best-tools-for-recruiters",
    component: BlogBest3Tools,
    meta: {
      requireAuth: false,
      name: "Best tools for recruiter",
      createdAt: new Date(2021, 4, 13),
      imageName: "jobboardy-hero-web.png",
      category: categories.jobSearch,
    },
  },
  {
    path: "/blog/why-linkedin-is-no-longer-a-good-place-to-find-candidates",
    component: BlogWhyLinkedinIsBad,
    meta: {
      requireAuth: false,
      name: "Why Linkedin is no longer a good place to find candidates",
      createdAt: new Date(2021, 3, 7),
      imageName: "jobboardy-hero-web.png",
      category: categories.jobSearch,
    },
  },
];
